export default [
  [`Российский размер`, `40`, `41`, `42`, `43`, `44`, `45`],
  [`Длина стельки, см`, `26,5`, `27`, `28`, `28,5`, `29`, `29,5`]
];
